/* PB&Me rotating headline word.
 *
 * Paired with snippets/pbandme-rotating-words.liquid, which emits only markup:
 *   <span class="pbm-rot-slot" data-pbm-rot='["smoothies","baking"]' data-pbm-rot-interval="2200">
 *     <em class="pbm-rot">smoothies</em>
 *   </span>
 *
 * The behaviour lives here rather than in an inline <script> beside that markup
 * because the snippet is rendered INSIDE a heading (the hero H1, the recipes H2).
 * An inline script there becomes part of the heading's text content — invisible on
 * screen, but it lands in h2.textContent and in anything that scrapes headings.
 * A separate file keeps the heading pure text, and one file serves every rotator on
 * the page however many there are.
 */
(function () {
  if (window.__pbmRotInit) return;
  window.__pbmRotInit = true;

  function init(slot) {
    var el = slot.querySelector('.pbm-rot');
    if (!el) return;

    var words;
    try {
      words = JSON.parse(slot.getAttribute('data-pbm-rot') || '[]');
    } catch (e) {
      return;
    }
    words = words
      .map(function (w) { return String(w).trim(); })
      .filter(Boolean);
    if (words.length < 2) return;

    // Reserve the width of the widest word so the line never reflows mid-rotation.
    function sizeSlot() {
      var cs = getComputedStyle(el);
      var probe = document.createElement('span');
      probe.style.cssText =
        'position:absolute;visibility:hidden;white-space:nowrap;font-family:' +
        cs.fontFamily + ';font-size:' + cs.fontSize + ';font-weight:' + cs.fontWeight +
        ';letter-spacing:' + cs.letterSpacing;
      document.body.appendChild(probe);
      var max = 0;
      words.forEach(function (w) {
        probe.textContent = w;
        max = Math.max(max, probe.offsetWidth);
      });
      document.body.removeChild(probe);
      slot.style.minWidth = Math.ceil(max) + 'px';
    }

    sizeSlot();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeSlot);

    // Headings are clamp()-sized, so the widest word changes width with the viewport.
    // Without re-measuring, the reserved slot keeps whatever the first paint measured —
    // a desktop-width gap left sitting on a phone.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sizeSlot, 150);
    });

    // Hold static for anyone who has asked for reduced motion.
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    var interval = parseInt(slot.getAttribute('data-pbm-rot-interval'), 10) || 2200;
    var i = 0;
    setInterval(function () {
      el.classList.add('out');
      setTimeout(function () {
        i = (i + 1) % words.length;
        el.textContent = words[i];
        el.classList.remove('out');
        el.classList.add('in');
        setTimeout(function () { el.classList.remove('in'); }, 440);
      }, 300);
    }, interval);
  }

  function boot() {
    document.querySelectorAll('.pbm-rot-slot[data-pbm-rot]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
